import React from 'react';



function Skills(props) {

    return (
<section className="skills" id="technologies">
           <div className="section-title">
            <h2>Skills</h2>
           </div>
           <div className="boxmodel skillscontainer">
               <h3></h3>
               <ul className="grid">
                   <li>
                       <div className="gridcontainer">
                           <img src="./assets/images/html.svg" alt=""/>
                           <p>HTML</p>
                       </div>
                   </li>
                   <li>
                    <div className="gridcontainer">
                        <img src="./assets/images/css.svg" alt=""/>
                        <p>CSS</p>
                    </div>
                </li>
                <li>
                    <div className="gridcontainer">
                        <img src="./assets/images/git.svg" alt=""/>
                        <p>GIT</p>
                    </div>
                </li>
                <li>
                  <div className="gridcontainer">
                      <img src="./assets/images/js.svg" alt=""/>
                      <p>JS</p>
                  </div>
              </li>
               </ul>
           </div>
        </section>

)}

export default Skills;